import { PRICE_IMPORT_STATUS, PRICE_IMPORT_WARNING } from "functions/priceImport";
import { formatPrice } from "functions/formatters";

/** Label voor de statuskolom. */
export const getStatusLabel = (t, line) => t(`price_import.status.${line.status}`);

/** Leesbare tekst bij een blokkerende fout. */
export const getErrorLabel = (t, line) => (line.error ? t(`price_import.errors.${line.error}`) : "");

const WARNING_META = {
  [PRICE_IMPORT_WARNING.LARGE_INCREASE]: { color: "orange" },
  [PRICE_IMPORT_WARNING.LARGE_DECREASE]: { color: "orange" },
  [PRICE_IMPORT_WARNING.NAME_MISMATCH]: { color: "gold" },
  [PRICE_IMPORT_WARNING.GROUP_PRICES]: { color: "purple" },
  [PRICE_IMPORT_WARNING.HIDDEN_PRODUCT]: { color: "default" },
  [PRICE_IMPORT_WARNING.NO_CURRENT_PRICE]: { color: "blue" },
  [PRICE_IMPORT_WARNING.ROUNDED]: { color: "default" },
  [PRICE_IMPORT_WARNING.AMBIGUOUS_SEPARATOR]: { color: "volcano" },
};

/**
 * Zet de waarschuwingen van een regel om naar tags met tooltip.
 * @returns {Array<{key: string, label: string, tooltip: string|null, color: string}>}
 */
export const getWarningTags = (t, line) =>
  (line.warnings || []).map((warning) => {
    const meta = WARNING_META[warning] || { color: "default" };
    let label;

    if (warning === PRICE_IMPORT_WARNING.LARGE_INCREASE || warning === PRICE_IMPORT_WARNING.LARGE_DECREASE) {
      label =
        line.deltaPercentage === null
          ? t("price_import.warnings.large_change_short")
          : t(`price_import.warnings.${warning}`, { percentage: formatPrice(Math.abs(line.deltaPercentage)) });
    } else {
      label = t(`price_import.warnings.${warning}`);
    }

    const tooltipKey = `price_import.warnings.${warning}_tooltip`;
    const tooltip = t(tooltipKey);

    return { key: warning, label, tooltip: tooltip === tooltipKey ? null : tooltip, color: meta.color };
  });

/** Alle bijzonderheden van een regel als één tekstregel (voor de Excel-export). */
export const getNotesText = (t, line) => {
  const parts = [];
  if (line.status === PRICE_IMPORT_STATUS.ERROR && line.error) parts.push(getErrorLabel(t, line));
  getWarningTags(t, line).forEach((tag) => parts.push(tag.label));
  return parts.join(" · ");
};
